export const ACCELEROMETER_TYPE = 'accelerometer';
export const ACCELEROMETER_CALCULATED_TYPE = 'accelerometer-calculated';
export const CAN_0_DIAGNOSTICS_TYPE = 'diag-can0';
export const CAN_1_DIAGNOSTICS_TYPE = 'diag-can1';
export const CAN_2_DIAGNOSTICS_TYPE = 'diag-can2';
export const CAN_3_DIAGNOSTICS_TYPE = 'diag-can3';
export const CUSTOM_TYPE = 'custom';
export const GATEWAY_LOAD_TYPE = 'gateway-load';
export const GATEWAY_LOGS_TYPE = 'gateway-logs';
export const GATEWAY_MEMORY_TYPE = 'gateway-memory';
export const GATEWAY_SIGNAL_TYPE = 'gateway-signal';
export const GPS_TYPE = 'GPS';
export const GPS_ALTITUDE_TYPE = 'altitude';
export const GPS_DISTANCE_TYPE = 'distance';
export const GPS_OTHER_TYPE = 'gps-other';
export const GPS_HEADING_TYPE = 'heading';
export const GPS_SPEED_TYPE = 'speed';
export const MODBUS_TCP_TYPE = 'modbus-tcp';
export const SCAN_CAN_TYPE = 'scan-can'; // legacy as of 8/2023
export const SCAN_J1939_TYPE = 'scan-j1939'; // legacy as of 8/2023

export const COLLECTION_TYPE_SET = new Set([
  ACCELEROMETER_TYPE,
  ACCELEROMETER_CALCULATED_TYPE,
  CAN_0_DIAGNOSTICS_TYPE,
  CAN_1_DIAGNOSTICS_TYPE,
  CAN_2_DIAGNOSTICS_TYPE,
  CAN_3_DIAGNOSTICS_TYPE,
  CUSTOM_TYPE,
  GATEWAY_LOAD_TYPE,
  GATEWAY_LOGS_TYPE,
  GATEWAY_MEMORY_TYPE,
  GATEWAY_SIGNAL_TYPE,
  GPS_TYPE,
  GPS_ALTITUDE_TYPE,
  GPS_DISTANCE_TYPE,
  GPS_HEADING_TYPE,
  GPS_OTHER_TYPE,
  GPS_SPEED_TYPE,
  MODBUS_TCP_TYPE,
]);
export const GATEWAY_TYPE_SET = new Set([
  GATEWAY_LOAD_TYPE,
  GATEWAY_LOGS_TYPE,
  GATEWAY_MEMORY_TYPE,
  GATEWAY_SIGNAL_TYPE,
]);
export const SCAN_TYPE_SET = new Set(SCAN_CAN_TYPE, SCAN_J1939_TYPE);

export const WATER_POND_TYPE = 'Water Pond';
export const WATER_PUMP_TYPE = 'Water Pump';
export const WATER_TRANSFER_TYPE_SET = new Set([
  WATER_POND_TYPE,
  WATER_PUMP_TYPE,
]);

export const READ_ONLY_TYPE = 'read_only';

// for use with PropTypes type checking
export const LEGACY_COLLECTION_TYPES = [
  ...COLLECTION_TYPE_SET,
  ...SCAN_TYPE_SET,
  ...WATER_TRANSFER_TYPE_SET,
  READ_ONLY_TYPE,
];

export const COLLECTION_TYPE_OPTIONS = [
  { label: 'GPS - Lat/Lng', value: GPS_TYPE },
  { label: 'GPS - Altitude', value: GPS_ALTITUDE_TYPE },
  { label: 'GPS - Speed', value: GPS_SPEED_TYPE },
  { label: 'GPS - Distance', value: GPS_DISTANCE_TYPE },
  { label: 'GPS - Other', value: GPS_OTHER_TYPE },
  { label: 'Accelerometer', value: ACCELEROMETER_TYPE },
  { label: 'Accelerometer - Calculated', value: ACCELEROMETER_CALCULATED_TYPE },
  { label: 'Gateway - Load Avg over 1 min', value: GATEWAY_LOAD_TYPE },
  { label: 'Gateway - Logs % used', value: GATEWAY_LOGS_TYPE },
  { label: 'Gateway - Memory % used', value: GATEWAY_MEMORY_TYPE },
  { label: 'Gateway - Signal Strength', value: GATEWAY_SIGNAL_TYPE },
  { label: 'Modbus - TCP', value: MODBUS_TCP_TYPE },
  { label: 'Custom', value: CUSTOM_TYPE },
  { label: 'CAN0 diagnostics', value: CAN_0_DIAGNOSTICS_TYPE },
  { label: 'CAN1 diagnostics', value: CAN_1_DIAGNOSTICS_TYPE },
  { label: 'CAN2 diagnostics', value: CAN_2_DIAGNOSTICS_TYPE },
  { label: 'CAN3 diagnostics', value: CAN_3_DIAGNOSTICS_TYPE },
];

export const EZ_GPS_TYPE = 'gps';
export const EZ_SATELLITES_IN_VIEW_TYPE = 'satellites_in_view';
export const EZ_COLLECTION_TYPE_OPTIONS = [
  { label: 'Custom CAN signal', value: CUSTOM_TYPE },
  { label: 'GPS signals', value: EZ_GPS_TYPE },
  { label: 'GPS satellite count', value: EZ_SATELLITES_IN_VIEW_TYPE },
];
export const EZ_COLLECTION_TYPE_SET = new Set([
  CUSTOM_TYPE,
  EZ_GPS_TYPE,
  EZ_SATELLITES_IN_VIEW_TYPE,
]);
